import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import { initSensors } from './util/initSensors'
import './style/base.scss'

Vue.config.productionTip = false

// 尝试初始化神策
initSensors()

new Vue({
  router,
  // 保留以后的 store 扩展
  // store,
  render: (h) => h(App),
}).$mount('#app')
